import {
	type ClientPropertyItemResponseDTO,
	ClientPropertyTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { propertyCarTitle } from "web_myplann/Portfolio/Helpers/propertyCarTitle";
import { REAL_ESTATE_TYPES } from "web_myplann/Portfolio/Helpers/realEstateTypes";

const isRealEstate = (
	property: ClientPropertyTypeEnum | null | undefined,
): boolean =>
	property !== undefined &&
	property !== null &&
	REAL_ESTATE_TYPES.has(property);

export const propertySubtitle = (
	data: ClientPropertyItemResponseDTO,
): string => {
	if (data.property === ClientPropertyTypeEnum.AutoMoto) {
		return propertyCarTitle(data.carBrand, data.carModel, data.carLicensePlate);
	}
	if (isRealEstate(data.property)) {
		return [data.location, data.locationMunicipality, data.locationZipCode]
			.filter(Boolean)
			.join(", ");
	}
	if (data.property === ClientPropertyTypeEnum.Art) {
		return data.propertyType ?? "";
	}
	return "";
};

export const propertyValue = (
	data: ClientPropertyItemResponseDTO,
): string | null => {
	if (isRealEstate(data.property)) {
		return data.marketValue ?? null;
	}
	return data.value ?? null;
};
